exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".capacity-container[data-v-0b82b5b8] {\n  width: 100%;\n  float: none;\n}\n.capacity-header[data-v-0b82b5b8] {\n  font-weight: bold;\n  margin-top: 10px;\n}\n.custom-paginated-table[data-v-0b82b5b8]  .md-field input {\n  border: 1px solid #ddd;\n  padding: 10px;\n}\n.card-icon[data-v-0b82b5b8] {\n  background: #ffb42b !important;\n}\n", ""]);

// exports
